module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/8.side_image-9ac4d9ec24da28233492c56a061ce303.png";